$(document).ready(function() {
	// Sliders initialization
	$('.refined-large-image').slick({
		 asNavFor: '.refined-image-thumbs',
		 infinite: true,
		 arrows: false,
		 slidesToShow: 1,
		 slidesToScroll: 1,
	});

	$('.refined-image-thumbs').slick({
		 vertical: true,
		 infinite: true,
		 slidesToShow: 5,
		 slidesToScroll: 5,
		 arrows: false,
		 centerMode: true,
		 focusOnSelect: true,
		 asNavFor: '.refined-large-image'
	});

	// Function to handle selection and data population
	function handleSelection(targetElement) {
		$('.refined-tag-select li').removeClass('selected');
		$('.product-quantity').val(1);
		targetElement.addClass('selected');
		$('.refined-image-thumbs').slick('slickGoTo', targetElement.attr('data-s-index'));
	
		let product = JSON.parse(targetElement.children('.prod-data').html());
		console.log(product);
		$('.targe-price-point').html(product.total_price_point);

		$('.product-quantity')
			.attr('name', 'item-' + product.sku)
			.attr('data-product-cost', product.total_price_point_un)
			.attr('data-product-gift-amount', product.gift_amount_un)
			.attr('data-product-product-amount', product.product_amount_un)
			.attr('data-product-weight', product.weight);
	
		$('.refined-cart-form').show();
	}

	// Tag selection click event
	$('.refined-tag-select li').on('click', function() {
		 handleSelection($(this));
	});

	// Auto-select when only one item exists
	let singleItem = $('.refined-tag-select li');
	if(singleItem.length === 1) {
		 handleSelection(singleItem);
	}
});
